export const releaseInfo =
 {
 	branch: "v7",
 	lastCommit: "12/17/2025 19:21:50",
 	lastTag: "",
 	buildType: "beta",
 	company: "Pinnacle Power Services",
 	user: "dmorris",
 	compileTime: "12/17/2025 19:22:28"
 }
